import React, { useState, useEffect } from 'react';
import { ChevronIcon } from '../../appearence/icons/chevron_icon';
import { useTranslation } from 'react-i18next';
import { Button } from '@chapche/ui';

const ExcludeFormButton = ({ callback, isVisible }) => {
    const [isBlockOpened, setIsBlockOpened] = useState(isVisible);
    const { i18n } = useTranslation();

    const closeItself = (e) => {
        e.preventDefault();
        e.stopPropagation();
        callback(!isVisible);
    };

    useEffect(() => {
        setIsBlockOpened(isVisible);
    }, [isVisible]);

    return (
        <Button
            variant="ghost"
            size="small"
            className="product__forms-exclude w-full justify-between"
            onClick={closeItself}
        >
            {i18n.t('app.page.product.excludeForm')}
            <ChevronIcon
                nameOfClass={`product__forms-icon product__forms-icon_exclude ml-8 ${isBlockOpened ? 'product__forms-icon_active' : ''}`}
            />
        </Button> 
    );
};

export default ExcludeFormButton;
